module.exports = __webpack_public_path__ + "img/list-view-white.79f0116d.svg";